import * as types from "../../constants";
import { AppDispatchType } from "../store";
import {
  fetchUnitImages as unitFetchUnitImages,
  deleteUnitImage as unitDeleteUnitImage,
  fetchCountUnitImages as unitFetchCountUnitImages,
  fetchUnitImagesByProperty as unitFetchUnitImagesByProperty,
  fetchUnitImagesByCompanyId as unitFetchUnitImagesByCompanyId,
  unitUpdateImage,
  unitPartialUpdateImage
} from "../../services/imageService";
import { DispatchOf } from "../utils";
import { UnitImageActions } from "../reducers/unitImagesReducer";
import { fetchA11yesById, fetchA11yesQuery } from "../../services/a11yesService";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchUnitImages(unitId: string, token: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitFetchUnitImages(unitId, token)
      .then((response) => {
        dispatch({
          type: "FETCH_UNIT_IMAGES",
          payload: response.results,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchUnitImagesByProperty(token: string, propertyId: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitFetchUnitImagesByProperty(token, propertyId)
      .then((response: any) => {
        dispatch({
          type: "FETCH_UNIT_IMAGES_BY_PROPERTY",
          payload: response.results,
        });
        dispatch({
          type: "LOADING_UNIT_IMAGES",
          payload: false
        })
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchUnitImagesByCompanyId(token: string, propertyId: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitFetchUnitImagesByCompanyId(token, propertyId)
      .then((response: any) => {
        dispatch({
          type: "FETCH_UNIT_IMAGES_BY_COMPANY_ID",
          payload: response.results,
        });
        dispatch({
          type: "LOADING_UNIT_IMAGES",
          payload: false
        })
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchCountUnitImages(token: string, companyId?: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitFetchCountUnitImages(token, companyId)
      .then((response) => {
        dispatch({
          type: "FETCH_COUNT_UNIT_IMAGES",
          payload: response,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearCountUnitImages() {
  return ({
    type: types.CLEAR_COUNT_UNIT_IMAGES,
  })
}

export function clearUnitImages() {
  return ({
    type: types.CLEAR_UNIT_IMAGES,
  })
}


export function updateUnitImage(index: number, id: string, data: any, token: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitUpdateImage(id, data, token)
      .then((response) => {
        dispatch({
          type: "UPDATE_UNIT_IMAGE",
          payload: { response, index },
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}
export function updateUnitImageByProperty(index: number, id: string, data: any, token: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitUpdateImage(id, data, token)
      .then((response) => {
        dispatch({
          type: "UPDATE_UNIT_IMAGE_BY_PROPERTY",
          payload: { response, index },
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function partialUpdateUnitImage(index: number, id: string, data: any, token: string) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitPartialUpdateImage(id, data, token)
      .then((response) => {
        dispatch({
          type: "UPDATE_UNIT_IMAGE",
          payload: { response, index },
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function deleteUnitImage(id: string, token: string, index: number) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitDeleteUnitImage(id, token)
      .then(() => {
        dispatch({
          type: "DELETE_UNIT_IMAGE",
          index
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function deleteUnitImagesByCompanyId(id: string, token: string, index: number) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitDeleteUnitImage(id, token)
      .then(() => {
        dispatch({
          type: "DELETE_UNIT_IMAGE_BY_COMPANY_ID",
          index
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}
export function deleteUnitImagesByProperty(id: string, token: string, index: number) {
  return async (dispatch: DispatchOf<UnitImageActions> & DispatchOf<ErrorsActions>) => {
    return unitDeleteUnitImage(id, token)
      .then(() => {
        dispatch({
          type: "DELETE_UNIT_IMAGE_BY_PROPERTY",
          index
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}
